import { v2Request } from "../helpers/request";

interface Announcement {
  id: number;
  message: string;
  time: string;
  isSeenBy: number[];
  title?: string;
  sender?: {
    firstName: string;
    lastName: string;
    email: string;
    photo?: string;
  };
}

export const markAnnouncementsRead = (announcementIds: number[]) => {
  return v2Request("/announcements/mark-read", {
    method: "POST",
    body: JSON.stringify({ announcementIds }),
  });
};

export const createAnnouncement = (payload: JObj) => {
  return v2Request("/createannouncement", {
    body: JSON.stringify(payload),
    method: "POST",
  });
};

export const fetchAllAnnouncements = (
  offset: number,
  rowCount: number,
  isAdmin: boolean,
  isAllAnnouncements: boolean = false
) => {
  return v2Request(
    `/announcements?offset=${offset}&rowcount=${rowCount}&is_admin=${isAdmin}&is_allAnnouncements=${isAllAnnouncements}`
  );
};

export const fetchMyAnnouncements = (page: number = 1, limit: number = 5) => {
  return v2Request(
    `/announcements/my-announcements?page=${page}&limit=${limit}`
  );
};

export const fetchAdminAnnouncements = (
  page: number = 1,
  limit: number = 10
) => {
  return v2Request(`/announcements/admin?page=${page}&limit=${limit}`);
};

export const deleteAnnouncement = (id: number) => {
  return v2Request(`/announcements/${id}`, {
    method: "DELETE",
  });
};

export const clearAllAnnouncements = (announcementIds: number[]) => {
  return v2Request("/announcements/clear-all", {
    method: "POST",
    body: JSON.stringify({ announcementIds }),
  });
};

export type { Announcement };
